module.exports = __webpack_public_path__ + "img/emoji_96.48563e42.png";